<bwh-lib-step-control-bar
  [langDropdown]="true"
  [prevBut]="prevBut"
  [closeBut]="closeBut"
  [currentStep]="wizardService?.currentStep"
  [previousStep]="wizardService?.previousStep"
  [steps]="wizardService?.totalSteps"
  (emitClose)="close()"
  (emitPrev)="goPrev()"
>
</bwh-lib-step-control-bar>
<div class="selecting-job text-center step-wrapper">
  <div class="main-header">
    <h1 class="main-title">{{ 'global.desired_occupations_title' | translate }}</h1>
    <p class="main-description mb-5">{{ 'global.desired_occupations_description' | translate }}</p>
  </div>
  <form class="scrollable-content" [formGroup]="form">
    <lib-single-select-search
      class="main-search"
      #searchAutocomplete
      [options]="filteredJobsList"
      [placeholder]="'global.search_for_your_job' | translate"
      [iconPath]="'/icons/search-icon.svg'"
      [staticIcon]="true"
      [myFloatLabel]="'never'"
      [addDebounce]="300"
      [clearInput]="true"
      [waitForOptionsChange]="true"
      [suggestionsOff]="true"
      [detectScrollToEnd]="true"
      (changed)="handleFilteredOptionClick($event)"
      (valueChanged)="handleMainSearchValueChanged($event)"
      (scrolledToEnd)="handleScrolledToEndSearch($event, -1)"
    >
    </lib-single-select-search>
    <div *ngIf="dataLoaded && selectedJobs.controls.length === 0" class="order-tip mt-3 mb-4" role="alert">
      {{ 'global.desired_occupations_tip' | translate }}
    </div>

    <div
      *ngIf="dataLoaded"
      cdkDropList
      [cdkDropListData]="selectedJobs.controls"
      class="selected-jobs scrollbar"
      formArrayName="selectedJobs"
      (cdkDropListDropped)="changePositionInList($event)"
    >
      <div cdkDrag [cdkDragData]="item" *ngFor="let item of selectedJobs.controls; let i = index" class="job-item">
        <bwh-lib-selected-item
          cdkDragHandle
          [formGroupName]="i"
          [name]="item.get('name').value"
          [listIcon]="true"
          [twoIcons]="false"
          [openIcon]="false"
          [index]="i + 1"
          (actionTriggered)="removeItem($event)"
        >
          <ng-template #itemContent>
            <span>{{ getFormControl(i, 'name').value }}</span>
          </ng-template>
        </bwh-lib-selected-item>
      </div>
    </div>

    <div *ngIf="dataLoaded && selectedJobs.controls.length === 0" class="empty-state-warning mt-5" role="alert">
      {{ 'global.desired_occupations_empty_warning' | translate }}
    </div>

    <ul class="next-button-container">
      <li *ngIf="prevBut === true">
        <button class="btn w-md h-lg primary prev-btn" type="button" (click)="goPrev()">
          {{ 'global.previous' | translate }}
        </button>
      </li>
      <li>
        <button class="btn w-md h-lg secondary" type="submit" (click)="nextStep()">
          {{ 'global.next_button' | translate }}
        </button>
      </li>
    </ul>
  </form>
</div>
